// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button-module--button--3aVdI","loading":"save-button-module--loading--1GLuM"};